export default __webpack_public_path__ + "static/media/LogoRoundWhite.29b6108c.svg";